export enum ClientType {
    ALL= 'all',
    FINANCIAL = 'financial',
    INSTALLER = 'installer',
    PARTNER = 'partner',
}
